// src/components/Footer.jsx
import React from "react";
import { useAppTheme } from "../context/AppThemeContext";
import { useTenant } from "../context/TenantContext";
import { useStudentProfile } from "../context/StudentProfileContext";
import { useTeacherProfile } from "../context/TeacherProfileContext";
import { normalizeRole, ROLE_TEACHER, STUDENT_ROLES } from "../utils/authRole";

const Footer = ({ isLoggedIn = false, hasAdminSidebar = false }) => {
  const { isDarkMode } = useAppTheme();
  const { isSubdomainTenant, schoolName: tenantSchoolName, activeTenant } = useTenant();
  const role = normalizeRole(localStorage.getItem("user"));
  const isStudentRole = STUDENT_ROLES.includes(role);
  const isTeacherRole = role === ROLE_TEACHER;
  const { studentProfile } = useStudentProfile();
  const { teacherProfile } = useTeacherProfile();
  
  const profileSchoolName = isStudentRole
    ? studentProfile?.schoolName || ""
    : isTeacherRole
      ? teacherProfile?.schoolName || ""
      : "";

  const effectiveSchoolName = tenantSchoolName || activeTenant?.schoolName || profileSchoolName;
  const showSchoolBranding = activeTenant?.brandingEnabled !== false && (isSubdomainTenant || (isLoggedIn && (isStudentRole || isTeacherRole))) && Boolean(effectiveSchoolName);

  const footerShellClass = isDarkMode
    ? "border-slate-800/90 bg-slate-950/92 text-slate-300 shadow-[0_-18px_40px_-28px_rgba(2,6,23,0.95)]"
    : "border-slate-200 bg-white/95 text-slate-700";
  const secondaryTextClass = isDarkMode ? "text-slate-400" : "text-slate-500";
  const supportTextClass = isDarkMode ? "text-slate-300" : "text-slate-600";

  return (
    <footer className={`fixed bottom-0 left-0 right-0 z-30 shrink-0 border-t backdrop-blur-xl ${hasAdminSidebar ? "lg:left-[248px]" : ""} ${footerShellClass}`}>
      <div className="mx-auto max-w-6xl px-4 py-2.5">
        <div className="flex flex-col items-center justify-between gap-1.5 text-[11px] sm:flex-row">
          <span className={`font-medium ${secondaryTextClass}`}>
            © {new Date().getFullYear()} {showSchoolBranding ? effectiveSchoolName : "ClassNX"}
            {showSchoolBranding && isSubdomainTenant && (
              <span className="ml-1 text-[10px] opacity-75">· Powered by ClassNX</span>
            )}
          </span>
          <a href="mailto:support@classnx.com" className={`font-medium transition hover:underline ${supportTextClass}`}>
            support@classnx.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
